import Vue from 'vue'
import Vuex from 'vuex'

import window from '@/store/modules/window'
import user from '@/store/modules/user'
import vendaRapidaNFCe from '@/store/modules/vendaRapidaNFCe'
import comandosValidacaoLog from '@/store/modules/comandosValidacaoLog'
import acessoRealtec from '@/store/modules/acessoRealtec'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        window,
        user,
        vendaRapidaNFCe,
        comandosValidacaoLog,
        acessoRealtec
    }
})